<template>
  <el-dialog
    class="mode search_criteria_outdialog schedule"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    :title="title"
    top="5vh"
    :visible="dialogVisible"
    append-to-body
    @close="close"
  >
    <div v-for="(item, index) in scheduleData.allTimeList" :key="index">
      <div class="time_title flex_center_align">
        <div class="square"></div>
        {{ item.time }}
      </div>
      <div class="content_text">
        {{ item.content }}［{{ item.acceptOrderKey }}］
      </div>
      <template v-if="index !== scheduleData.allTimeList.length - 1">
        <div class="line"></div>
      </template>
    </div>
    <div slot="footer" class="dialog-footer flex_end">
      <div class="flex_start flex_center_align">
        <el-button class="cancel_secondary" @click="close()">閉じる</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'ScheduleDetail',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      scheduleData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        dialogVisible: false,
      }
    },
    computed: {
      title() {
        if (this.scheduleData.time != null) {
          return (
            this.scheduleData.time.slice(0, 4) +
            '/' +
            this.scheduleData.time.slice(5, 7) +
            '/' +
            this.scheduleData.time.slice(8, 10)
          )
        } else {
          return ''
        }
      },
    },
    watch: {
      visible: function (val) {
        this.dialogVisible = val
      },
    },
    methods: {
      close() {
        this.dialogVisible = false
        this.$parent.update()
      },
    },
  }
</script>
